
export const DOMAIN_STRINGS = {
    docTypeInvoice: "EI02",
    docTypeAttachment: "FAKBIL",
    docTypeOriginalXML: "OVRDOK",
    docTypeConfidentialInvoice: "SEKFAKTURA", 
    docTypeConfidentialAttachment: "SEKBILAGA"
  };
  